import { Text, View } from 'react-native';
import Colors from '../../../constants/Colors';
import ExclamationIcon from '../../24pxIcons/ExclamationIcon';

const NextClean = () => (
  <View style={{
    flexDirection: 'row',
    marginBottom: 16,
    backgroundColor: Colors.light.hereworksWhite100,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue50,
    borderRadius: 10,
    padding: 16,
    alignItems: 'center',
    marginVertical: 8,
    width: '100%',
  }}>
    <ExclamationIcon />
    <Text style={{
      fontFamily: 'Roboto_400Regular',
      color: Colors.light.hereworksBlack400,
      fontSize: 16,
      marginLeft: 16,
    }}>
      {'According to historical data, the next cleaning and restocking should be done at 5pm'}
    </Text>
  </View>
);

export default NextClean;
